export default __webpack_public_path__ + "maps-examples-approximate-location-thumbnail-480-a57cd6130d77114491d14f7925b8a4ff.webp";